import { formatIQD, grandTotal, lineTotal, subtotal } from "../data/price";
import { emptyPriceItem } from "../data/defaults";
const toNumber = (value) => {
    const n = Number(value.replace(/[,\s]/g, ""));
    return Number.isFinite(n) && n >= 0 ? n : 0;
};
function MoneyInput({ value, onChange, label }) {
    return (<input inputMode="numeric" dir="ltr" aria-label={label} value={value ? formatIQD(value) : ""} placeholder="0" onChange={(e) => onChange(toNumber(e.target.value))}/>);
}
export function PriceEditor({ offer, onChange }) {
    const set = (key, value) => onChange({ ...offer, [key]: value });
    const setItem = (id, patch) => set("items", offer.items.map((it) => (it.id === id ? { ...it, ...patch } : it)));
    return (<div className="price-editor">
      <div className="grid-2">
        <label className="field">
          <span>المشروع</span>
          <input value={offer.project} onChange={(e) => set("project", e.target.value)}/>
        </label>
        <label className="field">
          <span>الموقع</span>
          <input value={offer.location} onChange={(e) => set("location", e.target.value)}/>
        </label>
        <label className="field">
          <span>رقم التلفون</span>
          <input dir="ltr" value={offer.phone} onChange={(e) => set("phone", e.target.value)}/>
        </label>
        <label className="field">
          <span>التاريخ</span>
          <input dir="ltr" value={offer.date} placeholder="2026/10/10" onChange={(e) => set("date", e.target.value)}/>
        </label>
        <label className="field">
          <span>رقم الفاتوره</span>
          <input dir="ltr" value={offer.quoteNumber} onChange={(e) => set("quoteNumber", e.target.value)}/>
        </label>
        <label className="field">
          <span>صالحة لغاية</span>
          <input dir="ltr" value={offer.validUntil} onChange={(e) => set("validUntil", e.target.value)}/>
        </label>
      </div>

      <div className="items">
        {offer.items.map((item, i) => (<div className="item" key={item.id}>
            <div className="item-head">
              <span>البند {i + 1}</span>
              <span className="item-total" dir="ltr">
                {formatIQD(lineTotal(item))} IQD
              </span>
              <button type="button" className="icon danger" title="حذف البند" disabled={offer.items.length <= 1} onClick={() => set("items", offer.items.filter((it) => it.id !== item.id))}>
                ×
              </button>
            </div>
            <div className="item-grid">
              <label className="field compact span-2">
                <span>الوصف</span>
                <input value={item.description} onChange={(e) => setItem(item.id, { description: e.target.value })}/>
              </label>
              <label className="field compact">
                <span>إطار</span>
                <input value={item.frame} onChange={(e) => setItem(item.id, { frame: e.target.value })}/>
              </label>
              <label className="field compact">
                <span>ابعاد اللوحة (سم)</span>
                <input dir="ltr" value={item.dimensions} placeholder="60 × 90" onChange={(e) => setItem(item.id, { dimensions: e.target.value })}/>
              </label>
              <label className="field compact">
                <span>العدد</span>
                <input type="number" min={0} dir="ltr" value={item.quantity} onChange={(e) => setItem(item.id, { quantity: Math.max(0, Math.floor(+e.target.value || 0)) })}/>
              </label>
              <label className="field compact">
                <span>سعر اللوحة (د.ع)</span>
                <MoneyInput label="سعر اللوحة" value={item.unitPrice} onChange={(n) => setItem(item.id, { unitPrice: n })}/>
              </label>
            </div>
          </div>))}
        <button type="button" className="btn ghost" onClick={() => set("items", [...offer.items, emptyPriceItem()])}>
          + إضافة بند
        </button>
      </div>

      <div className="grid-2">
        <label className="field">
          <span>رسوم التصميم والاستشارات</span>
          <MoneyInput label="رسوم التصميم والاستشارات" value={offer.designFee} onChange={(n) => set("designFee", n)}/>
        </label>
        <label className="field">
          <span>رسوم التوصيل</span>
          <MoneyInput label="رسوم التوصيل" value={offer.deliveryFee} onChange={(n) => set("deliveryFee", n)}/>
        </label>
        <label className="field">
          <span>رسوم زيارة الموقع</span>
          <MoneyInput label="رسوم زيارة الموقع" value={offer.siteVisitFee} onChange={(n) => set("siteVisitFee", n)}/>
        </label>
        <label className="field">
          <span>تخفيض</span>
          <MoneyInput label="تخفيض" value={offer.discount} onChange={(n) => set("discount", n)}/>
        </label>
      </div>

      <dl className="totals-summary">
        <div>
          <dt>المجموع الاولي</dt>
          <dd dir="ltr">{formatIQD(subtotal(offer))} IQD</dd>
        </div>
        <div className="strong">
          <dt>المجموع الكلي</dt>
          <dd dir="ltr">{formatIQD(grandTotal(offer))} IQD</dd>
        </div>
      </dl>
    </div>);
}
